import { useEffect, useRef, useState } from "react";

/**
 * Reveal element on scroll once it enters viewport.
 * Usage: const [ref, shown] = useReveal();
 *        <div ref={ref} className="reveal" data-shown={shown}>...</div>
 */
export const useReveal = (options = { threshold: 0.15 }) => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (!ref.current) return;
    const node = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShown(true);
          observer.unobserve(node);
        }
      },
      options,
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return [ref, shown];
};
